import { useEffect } from 'react';

// Leaving a booking form that holds typed work — one wording and one tab-close
// warning for every screen that mounts the form (« Plan d'occupation »,
// « Réservations »), so the two cannot drift apart.

/** The question asked before closing a form over unsaved changes. */
export const LEAVE_MESSAGE = 'Quitter sans enregistrer ? Les modifications de cette réservation seront perdues.';

/** Asks LEAVE_MESSAGE when `dirty`; true = the desk may leave (or nothing to lose). */
export const mayLeave = (dirty: boolean): boolean => !dirty || window.confirm(LEAVE_MESSAGE);

/** While `active`, closing or reloading the tab triggers the browser's warning. */
export function useWarnBeforeUnload(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const warn = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [active]);
}
